export default () => {
    if (!document.body.classList.contains('single-product')) {
        return;
    }

    const selects = document.querySelectorAll('select');

    selects?.forEach(select => {
        const optionsWithDataPrice = select.querySelectorAll('option[data-price]');

        if (optionsWithDataPrice.length > 0) {

            select.addEventListener('change', function () {
                const selectedOption = this.options[this.selectedIndex];

                if (selectedOption.getAttribute('data-price')) {
                    const price = selectedOption.getAttribute('data-price');
                    const priceContainer = select.closest('.product').querySelector('.price-wrapper .woocommerce-Price-amount.amount bdi');

                    if (priceContainer) {
                        priceContainer.innerHTML = `<span class="woocommerce-Price-currencySymbol">€</span>&nbsp;${price.replace('.', ',')}`;
                    }
                }
            });
        }
    });
}